import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-yes-or-no-cell',
  templateUrl: './yes-or-no-cell.component.html',
})
export class YesOrNoCellComponent {
  @Input() data: boolean;
}
